const sameAsField = (value, { field }, fields) => value === fields[field] ? null : 'Wrong value';

export default sameAsField;
